
import { useEffect, useRef, useState } from 'react';

export default function Hero() {
  const video1Ref = useRef<HTMLVideoElement>(null);
  const video2Ref = useRef<HTMLVideoElement>(null);
  const [activeVideo, setActiveVideo] = useState<1 | 2>(1);

  useEffect(() => {
    const v1 = video1Ref.current;
    const v2 = video2Ref.current;
    if (!v1 || !v2) return;

    // video2 は反転（右→左）
    v2.style.transform = 'scaleX(-1)';

    const handleV1Ended = () => {
      v2.currentTime = 0;
      v2.play();
      setActiveVideo(2);
    };

    const handleV2Ended = () => {
      v1.currentTime = 0;
      v1.play();
      setActiveVideo(1);
    };

    v1.addEventListener('ended', handleV1Ended);
    v2.addEventListener('ended', handleV2Ended);

    v1.play();

    return () => {
      v1.removeEventListener('ended', handleV1Ended);
      v2.removeEventListener('ended', handleV2Ended);
    };
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video 1: 左→右 */}
      <video
        ref={video1Ref}
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
        src="https://public.readdy.ai/ai/video_res/6e4e6cc8-6668-45a4-bc33-ed90300cd383.mp4"
        muted
        playsInline
        style={{ opacity: activeVideo === 1 ? 1 : 0, willChange: 'opacity' }}
      />
      {/* Video 2: 右→左（反転） */}
      <video
        ref={video2Ref}
        className="absolute inset-0 w-full h-full object-cover transition-opacity duration-1000"
        src="https://public.readdy.ai/ai/video_res/6e4e6cc8-6668-45a4-bc33-ed90300cd383.mp4"
        muted
        playsInline
        style={{ opacity: activeVideo === 2 ? 1 : 0, willChange: 'opacity', transform: 'scaleX(-1)' }}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32 text-center text-white">
        <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold mb-4 md:mb-6 leading-tight">
          私たちファーム建設は<br />創業43年の企業です
        </h1>
        <p className="text-base md:text-xl lg:text-2xl mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed">
          不動産購入からリフォームそして管理まで<br />
          「ワンストップ」でサービス提供出来るのが強みです
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="https://lin.ee/0JOwaod" 
            className="whitespace-nowrap px-6 md:px-8 py-3 md:py-4 bg-teal-500 hover:bg-teal-600 text-white text-base md:text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
          >
            お問い合わせ
          </a>
        </div>
      </div>
    </section>
  );
}
